import { enqueueSnackbar } from 'actions';

import {
	GetTopology2gRequest,
	GetTopology3gRequest,
	GetTopology4gRequest,
	GetTopologyLabels2gRequest,
	GetTopologyLabels3gRequest,
	GetTopologyLabels4gRequest,
	GetSitesIdsRequest,
	GetSiteIdLocationRequest
} from '../requests/MapDriveTestsRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_TOPOLOGY_2G = 'GET_TOPOLOGY_2G';
export const GET_TOPOLOGY_3G = 'GET_TOPOLOGY_3G';
export const GET_TOPOLOGY_4G = 'GET_TOPOLOGY_4G';
export const GET_TOPOLOGY_LABELS_2G = 'GET_TOPOLOGY_LABELS_2G';
export const GET_TOPOLOGY_LABELS_3G = 'GET_TOPOLOGY_LABELS_3G';
export const GET_TOPOLOGY_LABELS_4G = 'GET_TOPOLOGY_LABELS_4G';
export const GET_SITES_IDS = 'GET_SITES_IDS';
export const GET_SITE_ID_LOCATION = 'GET_SITE_ID_LOCATION';
export const TOGGLE_FILTERS = 'TOGGLE_FILTERS';
export const CLEAR_FORM = 'CLEAR_FORM';
export const TOGGLE_SUMMARY_DIALOG = 'TOGGLE_SUMMARY_DIALOG';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS,
});

const onGetTopology2g = (value) => ({
	type: GET_TOPOLOGY_2G,
	topology2gData: value
});

const onGetTopology3g = (value) => ({
	type: GET_TOPOLOGY_3G,
	topology3gData: value
});

const onGetTopology4g = (value) => ({
	type: GET_TOPOLOGY_4G,
	topology4gData: value
});

const onGetTopologyLabels2g = (value) => ({
	type: GET_TOPOLOGY_LABELS_2G,
	topologyLabels2gData: value
});

const onGetTopologyLabels3g = (value) => ({
	type: GET_TOPOLOGY_LABELS_3G,
	topologyLabels3gData: value
});

const onGetTopologyLabels4g = (value) => ({
	type: GET_TOPOLOGY_LABELS_4G,
	topologyLabels4gData: value
});

const onGetSitesIds = (value) => ({
	type: GET_SITES_IDS,
	sitesIds: value
});

const onGetSiteIdLocation = (value) => ({
	type: GET_SITE_ID_LOCATION,
	siteIdLocation: value
});

const onToggleFilters = (openFilters) => ({
	type: TOGGLE_FILTERS,
	openFilters,
});

const onClearForm = () => ({
	type: CLEAR_FORM
});

const onToggleSummaryDialog = (visible) => ({
	type: TOGGLE_SUMMARY_DIALOG,
	visible
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => (dispatch) => {
	dispatch(onResetFields());
};

export const GetTopology2g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopology2gRequest(userId, '2G', bands, coordinates).then(response => {
		dispatch(onGetTopology2g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology3g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopology3gRequest(userId, '3G', bands, coordinates).then(response => {
		dispatch(onGetTopology3g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology4g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopology4gRequest(userId, '4G', bands, coordinates).then(response => {
		dispatch(onGetTopology4g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels2g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabels2gRequest(userId, '2G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels2g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels3g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabels3gRequest(userId, '3G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels3g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels4g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabels4gRequest(userId, '4G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels4g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleFilters = (openFilters) => (dispatch) => {
	dispatch(onToggleFilters(openFilters));
};

export const ClearForm = () => (dispatch) => {
	dispatch(onClearForm());
};

export const ToggleSummaryDialog = (visible) => (dispatch) => {
	dispatch(onToggleSummaryDialog(visible));
};

export const GetSitesIds = () => async (dispatch) => {
	await GetSitesIdsRequest().then(response => {
		dispatch(onGetSitesIds(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSiteIdLocation = (siteId) => async (dispatch) => {
	await GetSiteIdLocationRequest(siteId).then(response => {
		dispatch(onGetSiteIdLocation(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
